"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNotEmpty = exports.isEmpty = exports.get = undefined;
exports.renameAction = renameAction;
exports.reducer = reducer;

var _reselect = require("reselect");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _raw = require("./raw");

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _get = (0, _reselect.createSelector)(Raw.localState, function (s) {
  return s.displayName;
});
var get = exports.get = (0, _reselect.createSelector)(_get, function (name) {
  return name || "Unnamed swarm";
});
var isEmpty = exports.isEmpty = _lodash2.default.negate(_get);
var isNotEmpty = exports.isNotEmpty = _lodash2.default.negate(isEmpty);

function renameAction(displayName) {
  return { type: "RENAME", displayName: displayName };
}
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case "RENAME":
      return action.displayName;
    default:
      return state || null;
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/display-name.js
// module id = 227
// module chunks = 0